export const formatColumn = (cell: any) => {
  cell.font = {
    size: 14,
    color: { argb: 'FFC041' },
    bold: true,
  };
  cell.alignment = {
    wrapText: true,
    horizontal: 'center',
    vertical: 'top',
  };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '7130A2' }, // Blue background
  };
  cell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  return cell;
};

export const formatRowData = (cell: any) => {
  cell.font = {
    size: 12,
  };
  cell.alignment = {
    wrapText: true,
  };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFFFF' }, // Blue background
  };
  cell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  return cell;
};

export const formatRowDataTotal = (cell: any) => {
  cell.font = {
    size: 12,
    bold: true,
  };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFFFF' }, // Blue background
  };
  cell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  return cell;
};
